import * as React from "react";

function SvgDown(props) {
  return <svg data-name="Calque 1" viewBox="0 0 20.89 16.1" width="1em" height="1em" {...props}><path d="M20.12.42c.66.38 1 1 .61 1.53L13 15.11c-.65 1.08-3 1.28-4.19.57a1.7 1.7 0 01-.61-.58L.15 1.94C-.43 1 .79 0 2.53 0h15.8a3.72 3.72 0 011.79.42z" fill="#153042" /></svg>;
}

export default SvgDown;